<template>
  <div class="df-container df-confirm" v-if="value">
    <div class="mask"></div>
    <div class="df-main confirm">
      <div class="container">
        <div class="title">{{info.title}}</div>
        <div class="content">{{info.content}}</div>
      </div>
      <div class="button">
        <div class="btn cancel" @click="close()">{{info.cancelButtonText}}</div>
        <div class="btn success" @click="success()">{{info.confirmButtonText}}</div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'confirm',
    data: function () {
      return {}
    },
    props: [
      'value',
      'info',
    ],
    created() {

    },
    watch: {},
    methods: {
      close() {
        this.$emit("on-hide");
      },
      success() {
        this.$emit("on-success");
      }
    },
  }
</script>

<style lang="scss" scoped type="text/scss">
  @import "css/common";

  .df-main {
    .button {
      display: flex;
      justify-content: center;
      font-size: 30px;
      .btn {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        box-sizing: border-box;
        // &.cancel {

        // }
        &.success {
          border-left: solid 1px #eaeaea ; /*no*/
          color: $mainColor;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/flexible-ui/confirm.vue